(() => {
  const motion = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-gzm-rail]').forEach(rail => {
      if (rail.dataset.gzmReady) return;
      rail.dataset.gzmReady = 'true';
      const track = rail.querySelector('[data-gzm-track]');
      const previous = rail.querySelector('[data-gzm-prev]');
      const next = rail.querySelector('[data-gzm-next]');
      if (!track || !previous || !next) return;
      const update = () => {
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      };
      previous.addEventListener('click', () => track.scrollBy({left: -track.clientWidth * .85, behavior: motion()}));
      next.addEventListener('click', () => track.scrollBy({left: track.clientWidth * .85, behavior: motion()}));
      track.addEventListener('scroll', update, {passive: true});
      if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
      update();
    });
    scope.querySelectorAll('[data-gzm-hero]').forEach(hero => {
      if (hero.dataset.gzmReady) return;
      hero.dataset.gzmReady = 'true';
      const track = hero.querySelector('[data-gzm-slides]');
      const slides = [...hero.querySelectorAll('[data-gzm-slide]')];
      const dots = [...hero.querySelectorAll('[data-gzm-dot]')];
      let active = 0;
      const sync = (index) => {
        active = index;
        dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === index)));
        slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
      };
      const go = (index) => {
        const next = (index + slides.length) % slides.length;
        track.scrollTo({left: next * track.clientWidth, behavior: motion()});
        sync(next);
      };
      hero.querySelector('[data-gzm-hero-prev]')?.addEventListener('click', () => go(active - 1));
      hero.querySelector('[data-gzm-hero-next]')?.addEventListener('click', () => go(active + 1));
      dots.forEach((dot, i) => dot.addEventListener('click', () => go(i)));
      track.addEventListener('scroll', () => sync(Math.round(track.scrollLeft / track.clientWidth)), {passive: true});
      hero.addEventListener('keydown', event => {
        if (!event.target.matches('[data-gzm-dot], [data-gzm-hero-prev], [data-gzm-hero-next]')) return;
        if (event.key === 'ArrowRight') { event.preventDefault(); go(active + 1); }
        if (event.key === 'ArrowLeft') { event.preventDefault(); go(active - 1); }
      });
      sync(0);
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:block:select', event => {
    const slide = event.target.closest('[data-gzm-slide]');
    if (slide) slide.parentElement.scrollTo({left: slide.offsetLeft, behavior: 'auto'});
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.gzm-header details[open]').forEach(details => {
      details.open = false;
      details.querySelector('summary')?.focus();
    });
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('.gzm-header details[open]').forEach(details => {
      if (!details.contains(event.target)) details.open = false;
    });
  });
})();
